import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { Text } from '$views/components'
import { Link } from '$views/components/Link'
import { routeProvider } from '$utils/routeProvider'
import history from '$utils/history'

interface Props {
  onClose: () => void
}

export const PrivacyPolicyModal: React.FC<Props> = ({ onClose }) => {
  const onClickPrivacyPolicy = () => history.push(routeProvider.privacyPolicy)

  return (
    <ModalWindow cookies onClose={onClose}>
      <Text title>Tratamiento de datos personales</Text>
      <Text marginTop="mini">
        Familiados Healthtech SL es el responsable del tratamiento de sus datos. La finalidad es gestionar los servicios
        que le presta la plataforma, conocer sus preferencias como usuario, mejorar nuestro servicio y mantenerle
        informado sobre nuestras novedades y ofertas.
      </Text>
      <Text marginTop="mini">
        Responsable: Familiados Healthtech SL. Finalidad: Enviar la información solicitada. Legitimación: Consentimiento
        del interesado. Destinatarios: No se comunicarán datos a terceros. Derechos: Acceso, rectificación o supresión,
        oposición, así como otros derechos.
      </Text>
      <Text marginTop="mini" marginBottom="small">
        Ante esta actividad le asisten a usted los derechos recogidos en nuestra{' '}
        <Link href="#" onClick={onClickPrivacyPolicy}>
          política de privacidad
        </Link>
      </Text>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/PrivacyPolicyModal/PrivacyPolicyModal.tsx